function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#000",
  d: "M10 0C4.477 0 0 4.477 0 10c0 3.372 1.802 6.676 4.774 9.813 1.019 1.075 2.108 2.055 3.197 2.922.382.304.737.573 1.057.804l.417.293c.336.224.774.224 1.11 0l.417-.293.506-.374c.176-.134.36-.278.551-.43 1.09-.867 2.178-1.847 3.197-2.922C18.198 16.676 20 13.372 20 10c0-5.523-4.477-10-10-10z",
  transform: "translate(2)"
}), React.createElement("path", {
  fill: "#00D06C",
  d: "M10 2c4.418 0 8 3.582 8 8 0 2.753-1.573 5.636-4.226 8.437-.95 1.003-1.97 1.921-2.99 2.734l-.263.206-.521.395-.27-.201c-.163-.125-.335-.258-.513-.4-1.02-.813-2.041-1.731-2.991-2.734C3.573 15.637 2 12.753 2 10c0-4.418 3.582-8 8-8z",
  transform: "translate(2)"
}), React.createElement("path", {
  fill: "#000",
  d: "M10 6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z",
  transform: "translate(2)"
}));

var SvgMapPinGreen = function SvgMapPinGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMapPinGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-pin-green.45b69175.svg";
export { ForwardRef as ReactComponent };